import { getIPS, updateIPS } from '../ips.api';
import { IpsData } from '../ips.types';

export const getRiskAssessmentIPS = async (clientId: string | number): Promise<IpsData> => {
	return getIPS(clientId, 'risk_assessment');
};

export const updateRiskAssessmentIPS = async ({
	clientId,
	payload,
}: {
	clientId: string | number;
	payload: FormData;
}): Promise<{ pdfId: string }> => {
	return updateIPS(clientId, 'risk_assessment', payload);
};
